var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#0EA5E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0204 18.0187L32.0842 30.9589M32.0656 30.9774L18.0204 45.0227M17.9988 16.9106L42.3648 16.9111C43.3525 16.9112 44.2996 17.3036 44.998 18.0019C45.6964 18.7003 46.0887 19.6475 46.0888 20.6351L46.0893 45.0011",
    stroke: "white",
    strokeWidth: 1.54918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrow);
export default __webpack_public_path__ + "static/media/bluearrow.781b0f10f606a1bbf1e03f42f6d03b8c.svg";
export { ForwardRef as ReactComponent };